<div class="container py-5 reactivation-page">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">Account reactivation</h2>
    <div class="text-muted">Verify the request before SwipFx Support reviews the account.</div>
  </div>

  <div class="card shadow-sm border-0">
    <div class="card-body p-4 p-md-5 text-center">
      <div *ngIf="loading" class="py-4">
        <div class="spinner-border text-primary"></div>
        <div class="text-muted mt-3">Verifying your reactivation request...</div>
      </div>

      <ng-container *ngIf="!loading && error">
        <div class="reactivation-icon reactivation-icon-error mx-auto mb-3">!</div>
        <h5 class="fw-bold">Verification unsuccessful</h5>
        <p class="text-muted mb-4">{{ error }}</p>
        <a routerLink="/support" class="btn btn-outline-primary me-2">Open support</a>
        <a routerLink="/auth/login" class="btn btn-primary">Go to login</a>
      </ng-container>

      <ng-container *ngIf="!loading && !error">
        <div
          class="reactivation-icon mx-auto mb-3"
          [ngClass]="isSuccessful() ? 'reactivation-icon-success' : 'reactivation-icon-warning'">
          {{ isSuccessful() ? '✓' : 'i' }}
        </div>

        <h5 class="fw-bold">
          {{ status === 'AlreadyActive' ? 'Account already active' :
             status === 'PendingReview' ? 'Request submitted' :
             'Further review required' }}
        </h5>
        <p class="text-muted mb-2">{{ message }}</p>
        <p class="small text-muted mb-4" *ngIf="ticketId">
          Support reference: {{ ticketId }}
        </p>

        <a routerLink="/auth/login" class="btn btn-primary me-2">Go to login</a>
        <a routerLink="/support" class="btn btn-outline-secondary">Open Help Centre</a>
      </ng-container>
    </div>
  </div>

  <div class="small text-muted text-center mt-3">
    SwipFx will never ask you to send your password, PIN, authenticator code, or recovery code.
  </div>
</div>
